// extracted by mini-css-extract-plugin
module.exports = {"ctaShoppingCartButton":"ShoppingCartCTAButton--ctaShoppingCartButton"};